module.exports = __webpack_public_path__ + "static/media/yellow_child.aedc1373.jpg";